import { NewsContentType } from '@/types/enum';
import image1 from '@/assets/images/news/detail/20210501/1.jpg';
import image2 from '@/assets/images/news/detail/20210501/2.jpg';
import image3 from '@/assets/images/news/detail/20210501/3.jpg';

export default {
  id: '20210501', //  模块 id
  title: '庆祝建党百年主题团建 叮咚青年重走乡村振兴之路', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text:
        '4月30日，以“重走乡村振兴之路”为主题的叮咚买菜主题团日活动在新丰村和环东村展开。本次活动由叮咚买菜团委与张江镇团委联合组织举办，叮咚买菜团干和团员青年参与了此次活动，在活动中参观了环东村源香民俗馆，聆听了“禾下乘凉梦，稻香见初心”情景党课，感受了叮咚买菜&孙桥溢佳研学基地现代农业的智能化。',
    },
    {
      type: NewsContentType.Text,
      text:
        '此次主题团日活动首先来到了新丰村，参观了新丰村源香民俗馆，馆内展示了上海居民70、80年代的生活用品，如搪瓷盆、“二八大杠”自行车、老式织布机等老物件，还有油盏火、煤油灯等老“家电”，有我们童年的记忆，也有那个时代生活的无奈。改革开放以前生活的艰难和苦楚在民俗馆中静静陈列，提醒着我们当代青年要珍惜这来之不易的美好生活。',
    },
    {
      type: NewsContentType.Image,
      src: [image1],
    },
    {
      type: NewsContentType.Text,
      text:
        '在感受了70、80年代乡村生活后，我们来到了“禾下乘凉梦，稻香见初心”情景党课现场，课上主讲洪钟奇老师以漫画的形式讲述了袁隆平从1960年到目前的“禾下乘凉梦”发展历程。袁隆平先生做到了让中国乃至让全世界的人能吃饱饭，坚守着自己的初心，一生醉心科研，将汗水洒在农田，将希望播进国人的心中，如今九十几岁的高龄，依然奋战在科研一线，用实际行动推动乡村振兴。袁隆平梦想实现过程也是乡村发展的一个投影，也让我们团员青年学习了乡村振兴的过程。',
    },
    {
      type: NewsContentType.Text,
      text:
        '最后，我们来到了叮咚买菜&孙桥溢佳研学基地，参观了热带植物园、番茄基地和无土栽培基地。随着时代的发展和科技的进步，乡村、农业也一步步的进入了智能化时代，叮咚买菜&孙桥溢佳研学基地已经实现了科学化种养殖，展示了现代农业的魅力。看着比人还高得番茄，种在管道里的生菜和在亚热带地区茁壮生长的各种热带植物，叮咚青年们都十分感慨。',
    },
    {
      type: NewsContentType.Image,
      src: [image2],
    },
    {
      type: NewsContentType.Image,
      src: [image3],
    },
    {
      type: NewsContentType.Text,
      text:
        '此次活动叮咚团员青年们从70、80年代的乡村走到了21实际的现代化农业基地，深深的感受到了在党的关怀下乡村的高速发展。希望我们叮咚青年心怀感恩，不断前行。',
    },
  ],
};
